import VueRouter from "vue-router";
import Vue from "vue";

import routes from "@/router/routes";
// import store from "@/store"

Vue.use(VueRouter);

let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;

VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(this, location, () => {
    }, () => {
    })
  }
}

VueRouter.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject)
  } else {
    originReplace.call(this, location, () => {
    }, () => {
    })
  }
}

export let router = new VueRouter({
  routes,
  mode: 'history',
  scrollBehavior() {
    return {y: 0}
  }
});

router.beforeEach((to, from, next) => {
  if (to.meta.title) {//判断是否有标题
    document.title = `${to.meta.title} - 恩莱吉能源科技`
  } else {
    document.title = '恩莱吉能源科技'
  }
  next()
})

// router.beforeEach(async (to, from, next) => {
//   let token = store.state.user.token
//   let name = store.state.user.user_info.name
//   if (token) {
//     // 登录后不能进入login页面
//     if (to.path === "/login") {
//       next("/home")
//     } else {
//       if (name) {
//         next()
//       } else {
//         // 没有name信息，需要请求
//         try {
//           await store.dispatch("user/getVerifyToken")
//           next()
//         } catch (e) {
//           // 有可能token过期了, 退出登录，清除token
//           await store.dispatch("user/userLogout")
//           next("/login")
//         }
//       }
//     }
//   } else {
//     const stopPaths = ['/diagnosis', '/history', '/device', '/fault', '/reason', '/programme', '/action']
//     const ok = stopPaths.every(path => {
//       return to.path.indexOf(path) === -1
//     })
//     if (ok) {
//       next()
//     } else {
//       next("/login?redirect=" + to.path)
//     }
//   }
// })


